const envMap = {
  production: {
    API_URL: 'https://clearsavebackend-prod-http.internal.cleartax.co',
    SAVE_URL: 'https://cleartax.in',
    FILING_URL: 'https://cleartax.in/apiv1',
    LEAD_SERVICE_URL:
      'https://leadservice-prod-https.internal.cleartax.co/leadservice',
    MF_PAGES_API_URL: 'https://mfpagesbackend-prod-https.internal.cleartax.co',
    GOOGLE_YOLO_CLIENT_ID:
      '788790720174-fn1kpj35qob5ro2p181vr6oigh3nvmo9.apps.googleusercontent.com',
  },
  staging: {
    API_URL: 'https://clearsavebackend-staging-http.internal.cleartax.co',
    SAVE_URL: 'https://cleartax-staging-http.internal.cleartax.co',
    FILING_URL: 'https://cleartax-staging-http.internal.cleartax.co/apiv1',
    LEAD_SERVICE_URL:
      'https://leadservice-dev-http.internal.cleartax.co/leadservice',
    MF_PAGES_API_URL:
      'https://mfpagesbackend-staging-https.internal.cleartax.co',
    GOOGLE_YOLO_CLIENT_ID:
      '788790720174-le48cvjl1jhi8q86qqta5lduoq99a7ef.apps.googleusercontent.com',
  },
  qa: {
    API_URL: 'https://clearsavebackend-qa-http.internal.cleartax.co',
    SAVE_URL: 'https://cleartax-qa-k8s.internal.cleartax.co',
    FILING_URL: 'https://cleartax-qa-k8s.internal.cleartax.co/apiv1',
    LEAD_SERVICE_URL:
      'https://leadservice-qa-http.internal.cleartax.co/leadservice',
    MF_PAGES_API_URL: 'https://mfpagesbackend-qa-https.internal.cleartax.co',
    GOOGLE_YOLO_CLIENT_ID:
      '788790720174-le48cvjl1jhi8q86qqta5lduoq99a7ef.apps.googleusercontent.com',
  },
  sandbox: {
    API_URL: 'https://clearsavebackend-qa-http.internal.cleartax.co',
    SAVE_URL: 'https://cleartax-qa-k8s.internal.cleartax.co',
    FILING_URL: 'https://cleartax-qa-k8s.internal.cleartax.co/apiv1',
    LEAD_SERVICE_URL:
      'https://leadservice-qa-http.internal.cleartax.co/leadservice',
    MF_PAGES_API_URL: 'https://mfpagesbackend-qa-https.internal.cleartax.co',
    GOOGLE_YOLO_CLIENT_ID:
      '788790720174-le48cvjl1jhi8q86qqta5lduoq99a7ef.apps.googleusercontent.com',
  },
  dev: {
    API_URL: 'https://clearsavebackend-dev-http.internal.cleartax.co',
    SAVE_URL: 'https://cleartax-staging-http.internal.cleartax.co',
    FILING_URL: 'https://cleartax-staging-http.internal.cleartax.co/apiv1',
    LEAD_SERVICE_URL:
      'https://leadservice-dev-http.internal.cleartax.co/leadservice',
    MF_PAGES_API_URL: 'https://mfpagesbackend-qa-https.internal.cleartax.co',
    GOOGLE_YOLO_CLIENT_ID:
      '470867333421-gd7ltu7ljf669v6ste0e5dnta2eipva9.apps.googleusercontent.com',
  },
  development: {
    API_URL: 'https://clearsavebackend-dev-http.internal.cleartax.co',
    SAVE_URL: 'https://cleartax-staging-http.internal.cleartax.co',
    FILING_URL: 'https://cleartax-staging-http.internal.cleartax.co/apiv1',
    LEAD_SERVICE_URL:
      'https://leadservice-dev-http.internal.cleartax.co/leadservice',
    MF_PAGES_API_URL: 'https://mfpagesbackend-qa-https.internal.cleartax.co',
    GOOGLE_YOLO_CLIENT_ID:
      '470867333421-gd7ltu7ljf669v6ste0e5dnta2eipva9.apps.googleusercontent.com',
  },
};

module.exports = envMap[process.env.NODE_ENV];



// WEBPACK FOOTER //
// ./configs/env-config.js